import { Widget } from '../core/domain/widget';

/** The loaded category's doc id, only when it is the category being booked (itb-dashboard#1214). */
export function categoryWidgetId(widget: Widget | null | undefined, inspectionType: unknown): string | undefined {
  if (!widget || typeof widget.id !== 'string' || widget.id === '') return undefined;
  return widget.inspectionType === inspectionType ? widget.id : undefined;
}
